<template>
  <div>
    <apexchart
      :width="width"
      type="donut"
      :options="chartOptions"
      :style="`max-width: ${maxWidth} !important;`"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'PieChartFinanceiro',

  components: {
    apexchart: VueApexCharts,
  },

  props: {
    labels: {
      type: Array | Object,
      required: true,
    },

    series: {
      type: Array | Object,
      required: true,
    },
  },

  data() {
    return {
      width: '100%',
      maxWidth: '485px',
      chartOptions: {
        labels: this.labels,
        chart: { width: 380, type: 'pie' },
        legend: { position: 'bottom' },
        tooltip: {
          enabled: true,
          y: { formatter: (value) => this.formatterMoeda(value) },
        },
      },
    }
  },

  methods: {
    formatterMoeda(value) {
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
  },

  mounted() {
    console.log('labels >>>> ', this.labels)
    console.log('series >>>> ', this.series)
  },
}
</script>
